import { render, staticRenderFns } from "./basic-container.vue?vue&type=template&id=6b979c4c&"
import script from "./basic-container.vue?vue&type=script&lang=js&"
export * from "./basic-container.vue?vue&type=script&lang=js&"
import style0 from "./basic-container.vue?vue&type=style&index=0&id=6b979c4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports